/**
 * documentSet Normalizr Schema
 */

import { schema } from 'normalizr';

import document from './document';
import user from './user';
import event from './event';

const documentSet = new schema.Entity('documentSets', {
    documents: [document],
    assignedUsers: [user],
    event
});

export default documentSet;
